import { ReturnRequestDto } from "@babackapp/private-api-client/types";
import { Badge } from "@babackapp/ui/components/badge";
import { Button } from "@babackapp/ui/components/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/ui/components/popover";
import { TagIcon } from "lucide-react";
import useTranslation from "@babackapp/translations/use-translation";

interface OrderTagsSectionProps {
  returnRequest: ReturnRequestDto;
}

export default function OrderTagsSection({
  returnRequest,
}: OrderTagsSectionProps) {
  const t = useTranslation();

  if (!returnRequest.orderTags || returnRequest.orderTags.length === 0) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="h-auto p-1">
          <TagIcon className="size-4 mr-1" />
          {t("returnDetail.orderTags.seeButton")}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80">
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2 text-sm font-medium">
            <TagIcon className="size-4" />
            <span>{t("returnDetail.orderTags.label")}</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {returnRequest.orderTags.map((tag) => (
              <Badge key={tag} variant="secondary" size="sm">
                {tag}
              </Badge>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
